import qs, {ParsedQs} from 'qs';

// TODO this does not need to be a hook
export function useQueryParams<T extends ParsedQs>(): T {
  return qs.parse(window.location.search.slice(1)) as T;
}
